import bs58 from 'bs58';
import { Buffer } from 'buffer';
import { toHex } from 'viem';
import { extractEvmAddressFromParams } from './EvmUtils';
import { extractSolanaAddressFromParams } from './SolanaUtils';
function convertBase64ToBase58(valueBase64) {
    const padded = valueBase64 + '='.repeat((4 - (valueBase64.length % 4)) % 4);
    const decoded = Buffer.from(padded, 'base64');
    return bs58.encode(new Uint8Array(decoded));
}
export function extractAddressFromRequest(request) {
    const { method, params } = request.params.request;
    if (method.startsWith('solana_')) {
        const solanaAddress = extractSolanaAddressFromParams(params);
        if (solanaAddress)
            return solanaAddress;
    }
    const evmAddress = extractEvmAddressFromParams(method, params);
    if (evmAddress)
        return evmAddress;
    return null;
}
export function formatRpcRequest(request) {
    const { method, params } = request.params.request;
    const chainNamespace = request.params.chainId.split(':')[0];
    let normalizedParams = Array.isArray(params) ? [...params] : params ? { ...params } : params;
    if (method === 'personal_sign' && Array.isArray(normalizedParams)) {
        const message = normalizedParams[0];
        if (typeof message === 'string' && !message.startsWith('0x')) {
            normalizedParams[0] = toHex(message);
        }
    }
    if (method === 'solana_signTransaction' && normalizedParams && !Array.isArray(normalizedParams)) {
        const txBase64 = normalizedParams.transaction;
        if (typeof txBase64 === 'string') {
            normalizedParams = {
                ...normalizedParams,
                transaction: convertBase64ToBase58(txBase64)
            };
        }
    }
    if (method === 'solana_signAllTransactions' &&
        normalizedParams &&
        !Array.isArray(normalizedParams)) {
        const txsBase64 = normalizedParams.transactions;
        if (Array.isArray(txsBase64)) {
            const base58Txs = txsBase64.map(convertBase64ToBase58);
            normalizedParams = { ...normalizedParams, transactions: base58Txs };
        }
    }
    return { method, params: normalizedParams, chainNamespace };
}
//# sourceMappingURL=RequestUtils.js.map